import React from 'react'
import { Icon, Table } from 'semantic-ui-react'
import DropDown from '../formComponents/dropDown'
import InputField from '../formComponents/inputField'
import moment from 'moment'



 const DisplayExchangeRate=({currencyList,onChange,copySelectedRow,saveExchangeRate,deleteRow,...rest})=>{

  const disablePreviousDateRecords=React.useMemo(()=>{
    const currentDate = moment()
    const  dateToBeCompare = moment(rest.toDate,"MM-DD-YYYY");
     return dateToBeCompare.diff(currentDate, "days")<0
  },[rest.toDate])
  return (
    <Table.Row  className={`${rest.isNewRow ? 'bgBlue' :''}`}>
    
    <Table.Cell>
    <DropDown
        id="fromCurrency"
       // label="From Currency"
        className='field-bg dropdown100 border-none'
        labelClass='text-none'
        isLabel={true}
        data={currencyList}
        value={rest.fromCcy}
        isDisabled={true}
                    />
    </Table.Cell>
    <Table.Cell>
    <DropDown
        id="toCurrency"
      //  label="To Currency"
        className='field-bg dropdown100 border-none'
        labelClass='text-none'
        isLabel={true}
        isDisabled={true}
        data={currencyList}
        value={rest.toCcy}
      />
    </Table.Cell>
    <Table.Cell>
    <InputField  
        className="date"
        id="fromDate"
        name="date"
        type="date"
       // label="From Date"
        isLabel={false}
        minDate={moment().format("MM-DD-YYYY")}
        maxDate={moment().endOf('month').format("MM-DD-YYYY")}
        clearInput={false}
        isDisabled={disablePreviousDateRecords || !rest.isNewRow}
        value={new Date(rest.fromDate)}//{convertDateToUTC(arrivalEpoch)} 
        onChange={(value) => onChange({id:rest.id,fromDate:moment(value).format("MM-DD-YYYY")})}
      />
    
              
    </Table.Cell>
    <Table.Cell>
     <InputField  
        className="date"
        id="toDate"
        name="date"
        type="date"
      //  label="To Date"
        isLabel={false}
        clearInput={false}
        isDisabled={true}
        value={new Date(rest.toDate)}//{convertDateToUTC(arrivalEpoch)} 
        onChange={(value) => onChange({id:rest.id,toDate:moment(value).format("MM-DD-YYYY")})}
      /> 
              
    </Table.Cell>
    <Table.Cell>
    <InputField  
        id="exchangeRates"
        name="exchangeRates"
        type="number"
      //  label="Exchange Rate"
        isLabel={false}
        clearInput={false}
        isDisabled={disablePreviousDateRecords || !rest.isNewRow}
        value={rest.exchangeRate}
        onChange={(value)=>onChange({id:rest.id,exchangeRate:value})}
      />
    </Table.Cell>
    <Table.Cell>
     {!disablePreviousDateRecords && <>
       {!rest.isNewRow && <Icon name='copy outline' size='large' onClick={()=>copySelectedRow(rest)} />}
       { rest.isNewRow && <>
       <Icon name='save outline' size='large' onClick={()=>saveExchangeRate(rest)} />
       <Icon name='trash alternate outline' size='large' onClick={()=>deleteRow(rest.id)} />

       </>
       }
      </>
     }
    </Table.Cell>
        </Table.Row>
  )
}
export default React.memo(DisplayExchangeRate)

 